import {gql} from 'apollo-angular';

export const GET_ALL_INSURERS = gql`
  query {
    insurers {
      id
      name
      shortName
      logo
      lobs {
        id
      }
    }
  }
`;

export const CORE_INSURERS_WITH_ACTIVE_LOB = gql`
  query coreInsurersWithActiveLob($lobId: Int!, $contractTypes: [PensionType]) {
    coreInsurersWithActiveLob(lobId: $lobId, contractTypes: $contractTypes) {
      id
      name {
        en
        de
        fr
        it
      }
      shortName {
        en
        de
        fr
        it
      }
      logo {
        en
        de
        fr
        it
      }
      category
    }
  }
`;

export const INSURERS_WITH_ACTIVE_LOBS_AND_AVAILABLE_PRODUCT = gql`
  query insurersWithActiveLobsAndAvailableProduct(
    $lobIds: [LobId!],
    $contractTypes: [PensionType],
    $interPension: Boolean
  ) {
    insurerInterview {
      insurer {
        withActiveLobsAndAvailableProduct(lobIds: $lobIds, contractTypes: $contractTypes, interPension: $interPension) {
          id
          name {
            en
            de
            fr
            it
          }
          shortName {
            en
            de
            fr
            it
          }
          logo {
            en
            de
            fr
            it
          }
          category
        }
      }
    }
  }
`;
